"use strict";

angular.module('PatientApp').controller('ProviderDetailsCtrl', function ($scope, $rootScope, $state, $filter, $log, _, ProvidersService, BillsService, ContextHelperService, PatientUsersService, LoadingIndicatorService, FinancingService, LinkedAccountsService, Compass, VueEventTransmitter, VuexStore) {
  var _providerId = $state.params.id,
      _sortAccounts = function _sortAccounts(accounts) {
    var partitions, financed, greaterThanZero, zero, lessThanZero;
    partitions = _.partition(accounts, function (acc) {
      return acc.financedBy && acc.amountDue > 0;
    });
    financed = partitions[0];
    partitions = _.partition(partitions[1], function (acc) {
      return acc.amountDue > 0;
    });
    greaterThanZero = _.sortBy(partitions[0], function (acc) {
      return new Date(acc.dueDate);
    });
    partitions = _.partition(partitions[1], function (acc) {
      return acc.amountDue === 0;
    });
    zero = partitions[0];
    lessThanZero = partitions[1];
    return greaterThanZero.concat(financed, lessThanZero, zero);
  },
      _getAccountById = function _getAccountById(id) {
    return _.find($scope.provider.accounts, {
      accountId: id
    });
  },
      _fetchHistoryForAccount = function _fetchHistoryForAccount(accountId) {
    VuexStore.dispatch('fetchAccountHistory', {
      id: accountId
    }).then(function (history) {
      var account = _getAccountById(accountId);

      account.activity = history;
      account.activityLimit = account.activity.length >= 15 ? 10 : account.activity.length;

      account.resetLimit = function () {
        //should be able to set this to undefined, but there's a bug with the limitTo filter: https://github.com/angular/angular.js/issues/10484
        if (account.activity) {
          account.activityLimit = account.activity.length;
        }
      };

      account.showMoreVisible = function () {
        return account.activity && account.activityLimit < account.activity.length;
      }; // flag for if we have performed this check
      // TODO: decide how to handle this if we fail


      account.activityFetched = true;
    });
  },
      _refreshLinkableNotification = function _refreshLinkableNotification() {
    LinkedAccountsService.fetchUnverified().then(function () {
      //if the provider doesn't have an encountergroup, then it cannot have any associated linked accts
      if ($scope.provider.encounterGroupId && LinkedAccountsService.hasUnverified($scope.provider.encounterGroupId)) {
        Compass.capture.event('account-linking', 'prompt', 'presented-provider-details');
        $scope.showLinkableNotification = true;
        $scope.linkableNotificationText = LinkedAccountsService.getNotificationText($scope.provider.encounterGroupId);
      } else {
        $scope.showLinkableNotification = false;
      }
    });
  },
      _refreshConfirmEmailNotification = function _refreshConfirmEmailNotification() {
    var user = PatientUsersService.getCurrentUser();
    $scope.showConfirmEmail = !user.emailVerified && !user.newUser && !user.newEmail;
    $scope.confirmEmailMessage = $filter('translate')('actions.confirmEmail', {
      email: user.email
    });
  },
      _loadingKeyProviderDetailsPromise = LoadingIndicatorService.loading(),
      _destroyVerificationListener = $rootScope.$on('accountVerification:updated', function () {
    _refreshLinkableNotification();
  }),
      _destroyUserSettingsUpdatedListener = $rootScope.$on('userSettings:updated', function () {
    _refreshConfirmEmailNotification();
  }),
      _getItemizedChargesForAccount = function _getItemizedChargesForAccount(account) {
    // for demos involving itemized charges, do something like:
    // account.itemizedCharges = { ... }
    account.itemizedCharges = undefined;
    return;
  };

  if (!_providerId) {
    $state.go('app.dashboard');
  }

  $scope.$on('$destroy', function () {
    _destroyVerificationListener();

    _destroyUserSettingsUpdatedListener();
  });

  _refreshConfirmEmailNotification(); //there has to be a better way of deciding to show the breadcrumb, but we can deal with that when we port this page


  VuexStore.dispatch('getProviders').then(function (providers) {
    // if we only have one provider, we omit the
    // providers/dashboard ui state. So do not offer the
    // breadcrumbs for this
    // also dont have the helper if we did not
    // navigate to providers first
    if (providers.length === 1 || $state.previous.name !== 'app.dashboard') {
      return;
    }

    ContextHelperService.showBreadCrumbs({
      label: $filter('translate')('actions.backToDashboard'),
      onClick: function onClick() {
        $state.go('app.dashboard');
      }
    });
  }).catch(function () {
    $log.error('Could not load providers to determine whether to show bread crumb');
  });

  $scope.completeAcct = function () {
    $rootScope.$emit('accountVerification:prompt');
  };

  $scope.confirmPhone = function () {
    $rootScope.$emit('confirmPhone:prompt');
  };

  $scope.confirmEmail = function () {
    $rootScope.$emit('confirmEmail:prompt');
  };

  $scope.messageProviderAboutAccount = function (provider, account) {
    var params = {
      secureCode: account.secureCode
    }; // send message for account with no bill

    if (!account.secureCode && account.estimateId) {
      var providerAccount = _.cloneDeep(provider);

      providerAccount.accounts = [account];
      params.useProviderAccount = providerAccount;
      params.reason = 11;
    }

    if (provider.requiresRedirectToBranded) {
      VueEventTransmitter.$emit('redirect:tab', {
        provider: provider,
        context: {
          stateGo: {
            to: 'app.dashboard.provider.details',
            toParams: {
              id: provider.id
            }
          },
          emit: ['message:compose', params]
        }
      });
    } else {
      VueEventTransmitter.$emit('message:compose', params);
    }
  };

  $scope.translationData = {};
  $scope.provider = {}; // populate the ui pieces that we already have from the dashboard

  VuexStore.dispatch('getProviderById', _providerId).then(function (provider) {
    provider.accounts = _sortAccounts(provider.accounts);

    _.forEach(provider.accounts, function (acc) {
      _getItemizedChargesForAccount(acc);
    });

    var acctsWithBalance = _.filter(provider.accounts, function (acc) {
      return acc.amountDue > 0;
    }),
        acctsWithZeroBalance = _.filter(provider.accounts, function (acc) {
      return acc.amountDue === 0;
    }); //we need to have at least one non-zero acct or else we would have an empty page with a button to 'show more'


    $scope.shouldHideZeroBalanceAccts = acctsWithBalance.length > 0 && acctsWithZeroBalance.length > 3;
    $scope.zeroBalanceHiddenVars = {
      count: acctsWithZeroBalance.length
    };
    $scope.provider = provider;

    _refreshLinkableNotification();

    $scope.translationData.provider = {
      name: provider.name,
      number: provider.billingPhoneNumber
    }; // for the fist item in accounts we have the history expanded
    // load the history for that account immediately

    if ((provider.accounts || []).length > 0) {
      _fetchHistoryForAccount(provider.accounts[0].accountId);
    }
  }, function () {
    //Handles the specific failure case of failing to load by provider id
    $log.error('Unable to load provider by Id');
    $state.go('app.dashboard');
  }).catch(function () {
    //catch any errors that ocurred during the "then" callback
    $log.error('Error loading provider details');
  }).finally(function () {
    _loadingKeyProviderDetailsPromise.then(function (key) {
      LoadingIndicatorService.complete(key);
    });
  }); // we are listening for this so we can reflect in the ui
  // the new threads that were added

  VueEventTransmitter.$on('message:newThreadCreated', function (creationDetails) {
    $log.log('New Thread Created, refetching account activity');
    var id = creationDetails.accountId,
        shouldUpdateAccountHistory = id && (_getAccountById(id) || {}).activityFetched; // only update the account history if the history has already been pulled
    // otherwise we will let the toggling of the activity history section handle
    // fetching

    if (shouldUpdateAccountHistory) {
      _fetchHistoryForAccount(creationDetails.accountId);
    }
  }); //delete VueEventTransmitter listener

  $scope.$on('$destroy', function () {
    VueEventTransmitter.$off('message:newThreadCreated');
  });

  $scope.manageAccount = function (accountId) {
    var account = _getAccountById(accountId);

    account.loadingVendor = true;
    account.failedToGoToVendor = false;
    FinancingService.manageAccount(account.secureCode).then(function (data) {
      window.location.href = data.redirect_url;
    }).catch(function () {
      account.failedToGoToVendor = true;
    }).finally(function () {
      account.loadingVendor = false;
    });
  };

  $scope.getHistory = function (id) {
    if (!_getAccountById(id).activity) {
      _fetchHistoryForAccount(id);
    }
  };

  $scope.makePayment = function (accountId) {
    var account = _getAccountById(accountId);

    if ($scope.provider.requiresRedirectToBranded) {
      VueEventTransmitter.$emit('redirect:tab', {
        provider: $scope.provider,
        context: {
          stateGo: {
            to: 'app.payment.start',
            toParams: {
              secureCode: account.secureCode,
              estimateId: account.estimateId
            }
          }
        }
      });
      return;
    }

    account.loadingPayment = true;
    $state.go('app.payment.start', {
      secureCode: account.secureCode,
      estimateId: account.estimateId,
      callback: function callback() {
        account.loadingPayment = false;
      }
    });
  }; // return whether or not this item type is something that
  // should be wrapped in a link that will ultimately make
  // a call to openEvent to route it


  $scope.shouldLink = function (itemType, itemId) {
    // cant link if we have no item id or if it's
    // not a linking type
    return itemId !== null && _.includes(['bill', 'collectionUpdate', 'message', 'payment', 'declinedPayment', 'canceledPayment', 'reversePayment', 'paymentPlanHeld', 'canceledPaymentPlan', 'paymentPlanCreated', 'paymentPlanCompleted', 'paymentPlanDeclined', 'transitionedEbill', 'ebill', 'agreement', 'agreementCancelled'], itemType);
  }; // route the the event to it's proper location


  $scope.openEvent = function (accountId, historyEventItemId, historyEventItemType) {
    var account = _getAccountById(accountId),
        item = _.find(account.activity, {
      itemId: historyEventItemId,
      itemType: historyEventItemType
    });
    /*
     CURRENT LOGIC GOALS
        -update if this changes
     bill : 'view bill',
    transitionedEbill : 'view bill',
    ebill : 'view bill',
    collection : 'no link',
    collectionStop : 'no link',
    collectionUpdate : 'view letter aka, view bill',
    collectionExtaction: 'no link',
    correspondence : 'no link',
    correspondenceOnly : 'no link',
    message : 'view message',
    changeOfAddress : 'no link',
    payment : 'view receipt',
    returnMail : 'no link',
    reversePayment : 'no link',
    balanceUpdate : 'no link',
    voidedPayment : 'no link',
    declinedPayment : 'view cancel receipt',
    canceledPayment : 'view receipt',
    paymentPlanHeld : 'plan receipt',
    canceledPaymentPlan : 'plan receipt',
    paymentPlanCreated : 'plan receipt',
    paymentPlanDeclined : 'plan receipt',
    paymentPlanCompleted : 'plan receipt',
     */


    if (_.includes(['payment', 'paymentPlan', 'declinedPayment', 'canceledPayment', 'reversePayment'], item.itemType)) {
      $state.go('app.dashboard.provider.details.receipt', {
        id: _providerId,
        receiptId: _.parseInt(item.itemId)
      });
    } else if (_.includes(['paymentPlanHeld', 'canceledPaymentPlan', 'paymentPlanCreated', 'paymentPlanDeclined', 'paymentPlanCompleted'], item.itemType)) {
      $state.go('app.dashboard.provider.details.plan-receipt', {
        id: _providerId,
        planId: _.parseInt(item.itemId)
      });
    } else if (_.includes(['agreement', 'agreementCancelled'], item.itemType)) {
      $state.go('app.dashboard.provider.details.paymentAgreement-receipt', {
        id: _providerId,
        paymentAgreementId: _.parseInt(item.itemId)
      });
    } else if (_.includes(['bill', 'collectionUpdate', 'transitionedEbill', 'ebill'], item.itemType)) {
      BillsService.openPdf(item.itemId);
    } else if (item.itemType === 'message') {
      VuexStore.commit('setThreadId', item.itemId);
      $state.go('app.messages.details', {
        threadId: item.itemId
      });
    }
  };

  $scope.viewBill = function (sCode) {
    BillsService.openPdf(sCode);
  };

  $scope.viewEstimate = function (estimateId) {
    $state.go('app.dashboard.provider.details.estimate-details', {
      id: _providerId,
      estimateId: estimateId
    });
  };

  $scope.viewAccountDetails = function (accountId) {
    $state.go('app.dashboard.provider.details.account-details', {
      id: _providerId,
      accountId: accountId
    });
  };

  $scope.getSubheaderText = function (account, provider) {
    if (!provider.active) {
      return $filter('translate')('labels.providerDisabledExplanation', $scope.translationData);
    } else if (account.financedBy || account.approvedFinanceApplication === 'ClearBalance') {
      return $filter('translate')('labels.servicedByFinancingVendor', {
        financedBy: account.financedBy || account.approvedFinanceApplication
      });
    } else if (account.isBadDebt) {
      return $filter('translate')('labels.badDebt');
    } else if (account.hasPendingBalance) {
      return '&nbsp';
    } else if (account.amountDue === 0) {
      return $filter('translate')('labels.noBalance');
    } else if (account.amountDue < 0) {
      return $filter('translate')('labels.negativeBalance');
    } else if (account.currentPlan) {
      return $filter('translate')('labels.remainingBalance');
    } else if (account.amountDue > 0 && account.secureCode) {
      if (provider.patientDueDateOverrideText) {
        return provider.patientDueDateOverrideText; //even though a bill can have a dueDate, some providers may not want to show that within the patientApp 
      } else {
        return account.dueDate ? account.friendlyDueDate : '&nbsp';
      }
    } else if (account.estimateId) {
      return $filter('translate')('labels.estimate', {
        date: $filter('dateFormat')(account.dateOfService, 'longDate')
      });
    }
  };

  $scope.showFinanceVendorInfo = function (account) {
    return account.financedBy === 'ClearBalance' || account.approvedFinanceApplication === 'ClearBalance';
  };

  $scope.buttonWarn = function (account) {
    return account.isPastDue && account.approvedFinanceApplication !== 'ClearBalance';
  };

  $scope.subheaderWarn = function (account) {
    return account.isPastDue && account.amountDue > 0 && !account.isBadDebt && !(account.financedBy || account.approvedFinanceApplication === 'ClearBalance');
  };

  $scope.triggerFinanceVendorInfo = function (account) {
    var text;

    if (account.financedBy === 'ClearBalance') {
      text = $filter('translate')('dialogs.clearBalanceInfoFunded');
    } else if (account.approvedFinanceApplication === 'ClearBalance') {
      text = $filter('translate')('dialogs.clearBalanceInfoApplied');
    } else {
      return;
    }

    VueEventTransmitter.$emit('simpleModal:showPrompt', {
      subcontent: text
    });
  };

  $scope.goToPaymentPlan = function (providerId, paymentPlanId) {
    Compass.capture.event('payment', 'paymentPlan', 'dashboardViewPlanDetailsClicked');
    $state.go('app.dashboard.provider.details.plan-receipt', {
      id: providerId,
      planId: _.parseInt(paymentPlanId)
    });
  };
});